import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'
import { TrackballControls } from 'three/examples/jsm/controls/TrackballControls'
import Stats from 'three/examples/jsm/libs/stats.module'
import { TorusGeometry, MeshPhongMaterial, DirectionalLight, OrthographicCamera, Vector3, BoxGeometry, MeshBasicMaterial, AmbientLight, Mesh, SphereGeometry, Camera, ObjectLoader } from 'three';
import { Params } from '../data/Params';
import { CameraUtil } from '../data/CameraUtil';
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js'
import { MyWave } from '../wave/MyWave';
import { RttScenes } from '../rtt/RttScenes';


export class Main{

    renderer    :THREE.WebGLRenderer;
    scene       :THREE.Scene;
    camera      :THREE.PerspectiveCamera;
    oCamera     :THREE.OrthographicCamera;
    control     :OrbitControls;

    stats       :Stats;
    isDebug     :boolean;
    clock       :THREE.Clock;
    loader      :OBJLoader;
    light       :THREE.DirectionalLight;
    rad         :number = 0;
    rttScenes      :RttScenes;

    waveMesh     :MyWave;
    count          :number =0;

    init(){
    
       Params.init();
       this.init2();
    }

    init2(){

        this.clock = new THREE.Clock(true);
        this.clock.start();
    
        this.renderer = new THREE.WebGLRenderer({
            canvas: document.querySelector('#webgl'),
            //antialias: true,
            preserveDrawingBuffer : true
        });
    
       //this.renderer.shadowMap.enabled=true;

        this.renderer.setPixelRatio(1);
        this.renderer.setClearColor(new THREE.Color(0x000000));
        this.renderer.setSize(window.innerWidth,window.innerHeight);
         
        this.scene = new THREE.Scene();

        
        this.camera = new THREE.PerspectiveCamera(
            30, window.innerWidth / window.innerHeight, 1, 5000);
        this.camera.position.set(0,0,320);
        this.camera.lookAt(new Vector3());
       
       let w = window.innerWidth;
       let h = window.innerHeight;
        this.oCamera = new OrthographicCamera(-w,w,h,-h,1,2000);
        this.oCamera.position.set(0,0,320);
        this.oCamera.lookAt(new Vector3());
        //let c = new CameraUtil(this.camera);


       
        this.control = new OrbitControls(this.camera,this.renderer.domElement);
        this.control.enabled=true;
        this.control.rotateSpeed = 2.0;
        this.control.panSpeed = 2.0;        


        window.addEventListener('resize', ()=>{
            this.onWindowResize();
        }, false)
        this.onWindowResize();

        this.light = new DirectionalLight(0xccccff);
        this.light.intensity=0.5;
        this.light.position.x = 600;
        this.light.position.y = 70;//10;
        this.light.position.z = 200;
        this.light.castShadow = true; // default false

        this.light.shadow.mapSize.width = 512; // default
        this.light.shadow.mapSize.height = 512; // default
        this.light.shadow.camera.near = 0.5; // default
        this.light.shadow.camera.far = 1500; // default
        let ww:number = 500;
        this.light.shadow.camera.left=-ww;
        this.light.shadow.camera.right=ww;
        this.light.shadow.camera.top=ww;
        this.light.shadow.camera.bottom=-ww;
        

        this.scene.add(this.light);

        let panel = Params.gui.addFolder("cam");

        panel.add(this.light.position,"x",-200,200).name("lightX").listen();
        panel.add(this.light.position,"y",-200,200).name("lightY").listen();
        panel.add(this.light.position,"z",-200,200).name("lightZ").listen();

        //panel.add(this.camera.position,"x").name("camX").listen();
        //panel.add(this.camera.position,"y").name("camY").listen();
        //panel.add(this.camera.position,"z").name("camZ").listen();


        Params.dLight = this.light;

        let aa:AmbientLight = new AmbientLight(0xcccccc);
        this.scene.add(aa);


        this.rttScenes = new RttScenes();
        //this.scene.add(this.rttScenes);


        this.waveMesh = new MyWave();
        this.waveMesh.init(this.renderer,this.rttScenes);
        this.scene.add(this.waveMesh);


        document.addEventListener('keydown', (event) => {
            const keyName = event.key;
            if(keyName=="s"){
                this.download();
            }
        });


        this.tick();
       
    }

    tick(){

        this.count++;
        console.log(this.count);
        if(this.count==300){
            Params.preview();
        }

        
        //インパルス発生
        //if(Params.random()<1){

        
            let xx = Params.random();
            let yy = Params.random();

            let amp = 0.03;
            let size = 15+85*Params.random();
            if(Params.random()<0.8){
                amp = 0.01*Params.random();
                size = 5+10*Params.random();
            }
            this.waveMesh.addImpulse(xx,yy,amp,size);
            this.rttScenes.addImpulse(xx,1-yy);
            
        //}

        this.rttScenes.update(
            this.renderer,
            this.waveMesh.getTexture()
        );

        this.waveMesh.update();


        //this.control.update();
        //this.light.position.x = 10 * Math.cos(this.rad);
        //this.light.position.z = 10 * Math.sin(this.rad);
        //this.rad+=0.007;
        
        this.renderer.render(this.scene, this.camera);//this.camera);

        //this.download();
        
        window.setTimeout(()=>{
            this.tick();
        },1000/60);
        
        //    this.tick();
        //});

    }

    
    download(){  
        let dom = document.getElementById("webgl") as HTMLCanvasElement;
        let link = document.createElement('a')
        link.href = dom.toDataURL('image/png')
        link.download = 'ripples.png'
        this.count++;
        link.click();
    }
    

    onWindowResize(){

        this.camera.aspect = window.innerWidth / window.innerHeight;
        this.camera.updateProjectionMatrix();

        let planeSize = 100;
        const fovRad = (this.camera.fov / 2) * (Math.PI / 180);//角度
        let distance = planeSize / (2*Math.tan(fovRad));

        if(window.innerWidth>window.innerHeight){
   
            const aspectRatio = window.innerWidth / window.innerHeight;            
            // 水平方向の視野角 FOV_horizontal を計算
            const FOV_horizontal = 
            Math.atan( Math.tan(fovRad / 2) * aspectRatio );
            // カメラからのオブジェクトまでの距離 d を計算
            distance = 0.5*planeSize / (2 * Math.tan(FOV_horizontal));
        }

        this.camera.position.set(0,0,distance);//距離を指定




        //console.log(distance);
        //let scale:number = window.innerHeight/100;//大きさ指定


        let oW = window.innerWidth*0.1;
        let oH = window.innerHeight*0.1;

        
        this.oCamera.left=-oW;
        this.oCamera.right=oW;
        this.oCamera.top=oH;
        this.oCamera.bottom=-oH;
        this.oCamera.updateProjectionMatrix();
        


        //でかい方に合わせるあれ
        let ww:number = window.innerWidth;
        let hh:number = window.innerHeight;
        
        this.renderer.setSize(ww, hh);
    }

}